import React, { useContext, useEffect, useState } from 'react';
import { makeStyles } from '@material-ui/core/styles';

import { GET_STARTED_CHECKLIST_ITEM_STATUS } from '~/constants/get-started';
import OnboardingProvider from '~/contexts/OnboardingProvider';
import { PersonContext } from '~/contexts/PersonContext';
import { create, patch, find } from '~/feathersFunctionalWrapper';
import OnboardingRoutes from '~/routes/OnboardingRoutes';

import OnboardingLayout from './Layout';

const useStyles = makeStyles(() => ({
  content: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    height: '100%',
    padding: '32px',
  },
}));

function Container() {
  const [isLoading, setIsLoading] = useState(true);
  const classes = useStyles();
  const { partnerName, organizationId, setOrganizationId, setIsTourVisible, subscriptionDate, setContextState } =
    useContext(PersonContext);

  const isNoOnboardingExperiment = !partnerName;

  useEffect(() => {
    async function skipOnboarding() {
      await patch('organizations', organizationId, {
        showWelcome: false,
      });
      let checklist = { organizationId };
      if (subscriptionDate) {
        checklist = { ...checklist, subscribe: GET_STARTED_CHECKLIST_ITEM_STATUS.COMPLETED };
      }
      const propertiesResult = await find('properties', { query: { organizationId } });
      const yodleeTransactionsResult = await find('yodlee-transactions', { query: { organizationId } });
      if (propertiesResult.total) {
        checklist = { ...checklist, addProperty: GET_STARTED_CHECKLIST_ITEM_STATUS.COMPLETED };
      }
      if (yodleeTransactionsResult.total) {
        checklist = { ...checklist, importTransaction: GET_STARTED_CHECKLIST_ITEM_STATUS.COMPLETED };
      }
      await create('get-started-checklist', checklist);
      setContextState({ showWelcome: false });
      setIsTourVisible(true);
    }
    if (isNoOnboardingExperiment) {
      skipOnboarding();
    } else {
      setIsLoading(false);
    }
  }, [
    isNoOnboardingExperiment,
    organizationId,
    setIsTourVisible,
    setOrganizationId,
    setContextState,
    subscriptionDate,
  ]);

  if (isLoading) {
    return null;
  }

  return (
    <OnboardingLayout className={classes.content}>
      <OnboardingProvider>
        <OnboardingRoutes />
      </OnboardingProvider>
    </OnboardingLayout>
  );
}

export default Container;
